import ActivationSuccessDialog from '@Containers/RemoteAccess/Components/ActivationSuccessDialog';
import ActivationErrorDialog from '@Containers/RemoteAccess/Components/ActivationErrorDialog';
import LoginPromptDialog from '@Containers/RemoteAccess/Components/LoginPromptDialog/LoginPromptDialog';
import RemoteAccessDialogContainer from './RemoteAccessDialogContainer';
import {
  typeOfRemoteAccessDialog,
  typeOfRemoteAccessActivationSuccessDialog,
  typeOfRemoteAccessActivationErrorDialog,
  typeOfRemoteAccessLoginPromptDialog,
} from './RemoteAccessDialogConstants';

export default {
  [typeOfRemoteAccessDialog]: RemoteAccessDialogContainer,
  [typeOfRemoteAccessActivationSuccessDialog]: ActivationSuccessDialog,
  [typeOfRemoteAccessActivationErrorDialog]: ActivationErrorDialog,
  [typeOfRemoteAccessLoginPromptDialog]: LoginPromptDialog,
};
